import { render } from "./SecurityAlerts.vue?vue&type=template&id=c1fc5766&scoped=true&ts=true"
import script from "./SecurityAlerts.vue?vue&type=script&lang=ts"
export * from "./SecurityAlerts.vue?vue&type=script&lang=ts"

import "./SecurityAlerts.vue?vue&type=style&index=0&id=c1fc5766&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jenkinsuser\\AppData\\Local\\Jenkins\\.jenkins\\workspace\\UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1fc5766"]])

export default __exports__